import React, { useEffect, useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { getErrorMessage, formatDecimal } from '../../utils/helper'

const GooglePayDC = (props) => {
    // const [isRendered, setIsRendered] = useState(true)
    const [divChilds, setDivChilds] = useState(0)

    const { faciltyData, payableAmount, getValues, onSubmit, setIsSubmittingForm, setIsLoading, notify } = props
    useEffect(() => {
        const restrictedDiv = document.getElementById('google-pay-button')
        const childCount = restrictedDiv?.children?.length
        setDivChilds(childCount == 0 ? 1 : childCount)
    }, [])

    useEffect(() => {
        function ensureSingleChild(div, newChild) {
            // If the div has more than one child, remove all but the last one
            while (div?.children?.length > 1) {
                div.removeChild(div?.firstElementChild)
            }
            // If the div has no children, simply append the new child
            if (div?.children?.length === 0) {
                div?.appendChild(newChild)
            } else {
                // Otherwise, replace the current child with the new child
                div?.replaceChild(newChild, div.firstElementChild)
            }
        }
        const restrictedDiv = document.getElementById('google-pay-button')
        // Example: Adding new content
        const newElement = document.createElement('p')
        // newElement.textContent = 'This is the new single child content.'
        // Call the function to ensure there's only one child in the div
        ensureSingleChild(restrictedDiv, newElement)
        return () => {
            console.log('')
        }
         
    },[EMPTY_ARRAY, divChilds])
    
    useEffect(() => {
        if (payableAmount && divChilds == 1) {
            window.DatacapGooglePay.init(
                getToken(payableAmount),
                faciltyData?.facility_payment_details?.wallet_datacap_token,
                faciltyData?.facility_payment_details?.wallet_datacap_mid,
                faciltyData?.facility_payment_details?.wallet_datacap_gpay_merchant,
                // '2546bc0ec6304d92a576a84699624456',
                // 'PARKESANJ5EI',
                // '100615579708305730',
                formatDecimal(payableAmount)
            )
        }
        
    }, [EMPTY_ARRAY, faciltyData, divChilds])

   
    let googlePayWindow
    let intervalId

    const onGooglePayLoaded = () => {
        const originalOpen = window.open
        window.open = function(url, name, specs) {
            const newWindow = originalOpen(url, name, specs)
            if (url.startsWith('https://pay.google.com/')) {
                googlePayWindow = newWindow
                // Call API for Storing Logs
                monitorWindowClosed()
            }
            return newWindow
        }
    }

    const monitorWindowClosed = () => {
        intervalId = setInterval(() => {
            if (googlePayWindow && googlePayWindow.closed) {
                // Call API for Storing Logs
                clearInterval(intervalId)
            }
        }, 500)
    }

    document.addEventListener('DOMContentLoaded', () => {
        // Ensure onGooglePayLoaded is called after the Google Pay script is loaded
    })
    
        

    const getToken = (payable_amount) => {
        onGooglePayLoaded()
        // Tokenization Callback
            const tokenCallback = async function (tokenResponse) {
                return new Promise(function (resolve, reject) {
                    // If error, show error
                    if (tokenResponse.Error) {
                        alert('Token error: ' + tokenResponse.Error)
                        return
                    }
                    // If good, call Pay API
                    var token = tokenResponse.Token
                    var headers = {}
                    headers['Content-Type'] = 'application/json'
                    headers['Authorization'] = faciltyData?.facility_payment_details?.wallet_datacap_mid
                    headers['User-Agent'] = 'AwesomePOS/1.2.3'
                    var payApiRequest = [
                        { Amount: payable_amount ? formatDecimal(payable_amount) : formatDecimal(0), Token: token }
                    ]
                    setIsSubmittingForm(true)
                    setIsLoading(true)
                    fetch('https://pay.dcap.com/v1/credit/sale', {
                        method: 'POST',
                        body: JSON.stringify(payApiRequest),
                        headers: headers
                    }).then(function (payApiResponse) {
                        payApiResponse?.json()?.then(function (json) {
                            setIsSubmittingForm(false)
                            // setIsLoading(false)
                            if (payApiResponse?.status && payApiResponse?.status != 200) {
                                notify('error', 'Error: ' + json.Message)
                                const formData = getValues()
                                const finalData = {...formData, walletPay : json}
                                finalData.paymentMethods = 'GPAY'
                                reject('Error' + json.Message)
                                onSubmit(finalData)
                            }
                            else {
                                const formData = getValues()
                                const finalData = {...formData, walletPay: json}
                                finalData.paymentMethods = 'GPAY'
                                resolve('Approved' + json.Message)
                                onSubmit(finalData)
                            }
                        })
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        setIsLoading(false)
                        notify('error', err ? err : getErrorMessage(err))
                    })
                }).catch((err) => {
                    notify('error', err ? err : getErrorMessage(err) )
                })
            }	
            return tokenCallback
        }

    return (
            <div className="payButton d-flex justify-content-center" id='google-pay-button'></div>
    )
}
GooglePayDC.propTypes = {
   faciltyData: PropTypes.object, 
   getValues: PropTypes.func, 
   onSubmit: PropTypes.func,
   setIsSubmittingForm: PropTypes.func,
   setIsLoading: PropTypes.func,
   notify: PropTypes.func,
   payableAmount: PropTypes.number,
}

GooglePayDC.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
    setIsLoading: noop,
    notify: noop,
    payableAmount: 0,
}
export default GooglePayDC